/**
 * Map Layer Utilities
 *
 * NOTA: Los estilos de capas ahora están centralizados en:
 * - config/mapStyle.json (definiciones de capas)
 * - config/mapStyleConfig.js (funciones y constantes de colores)
 *
 * Este archivo solo contiene funciones de utilidad para manipular capas.
 */

/**
 * Removes all lotes layers from the map
 * Used when project is in EDICION or ARCHIVADO status
 * @param {Object} map - Mapbox GL JS map instance
 */
export const removeLotesLayersFromMap = (map) => {
  if (!map) return;

  const layerIds = [
    "lotes-layer-stroke",
    "lotes-layer-highlighted",
    "lotes-layer-highlight-stroke",
    "lotes-layer-status",
    "lotes-layer-labels"
  ];

  layerIds.forEach(layerId => {
    try {
      if (map.getLayer(layerId)) {
        map.removeLayer(layerId);
      }
    } catch (e) {
      // Layer might not exist, ignore
    }
  });
};
